// Base
import Image from 'next/image'

// Components
import { Flex, Text, Box } from 'yard-utilities/components'
import Section from '@components/v25/section/Section'

// Assets
import GuaranteeImage from '@images/v25/badges/money-back-guarantee.png'

const MoneyBackGuarantee = () => {
  return (
    <Section padding={[32, 0]}>
      <Box
        borderRadius={{ sm: [16] }}
        padding={{ sm: [32] }}
        backgroundColor="white"
      >
        <Flex flexDirection="column" center rowGap={{ sm: 24 }}>
          <Image
            src={GuaranteeImage}
            alt="Money back guarantee badge"
            width={96}
            height={96}
          />

          <Flex flexDirection="column" center rowGap={{ sm: 16 }}>
            <Text
              tagName="h3"
              variant="title-5"
              align="center"
              transform="capitalize"
            >
              30 días de garantía de devolución
            </Text>
            <Text
              tagName="p"
              variant="body-1"
              align="center"
              textColor="grey-2"
            >
              Si por lo que sea no te enamoras de RatePunk, simplemente te
              reembolsaremos tu dinero, sin hacer preguntas
            </Text>
          </Flex>
        </Flex>
      </Box>
    </Section>
  )
}

export default MoneyBackGuarantee
